import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import env from '@tencent/vft-common/env';
import openapp from '@tencent/vft-common/openapp';
import Clipboard from '@tencent/vft-common/clipboard';
import store from '@/store';

function hackLitApp(vm) {
  var result = false;

  try {
    if (env.isLiteApp) {
      result = true;
      vm.customAlert({
        msg: '请到腾讯视频APP内参与',
        confirmText: '前往腾讯视频APP',
        confirm: function () {
          var _confirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var schemaUrl;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    schemaUrl = "tenvideo2://?action=10&openurl=".concat(encodeURIComponent(window.location.href));

                    if (!openapp.canGetInstallState) {
                      _context.next = 12;
                      break;
                    }

                    _context.next = 4;
                    return openapp.getInstallState();

                  case 4:
                    if (!_context.sent) {
                      _context.next = 9;
                      break;
                    }

                    _context.next = 7;
                    return openapp.launch(schemaUrl);

                  case 7:
                    _context.next = 10;
                    break;

                  case 9:
                    vm.toast('请先安装腾讯视频app');

                  case 10:
                    _context.next = 14;
                    break;

                  case 12:
                    _context.next = 14;
                    return openapp.launch(schemaUrl);

                  case 14:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function confirm() {
            return _confirm.apply(this, arguments);
          }

          return confirm;
        }()
      });
    }
  } catch (e) {
    console.error(e);
  }

  return result;
}

function hackWeibo(vm) {
  var result = false;
  var ua = window.navigator.userAgent;
  var regTxt = 'weibo';
  var reg = new RegExp(regTxt, 'i');
  var isWeibo = reg.test(ua);

  try {
    if (isWeibo) {
      result = true;
      vm.customAlert({
        msg: '请复制链接前往微信参与活动',
        confirmText: '复制链接',
        confirm: function () {
          var _confirm2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    // eslint-disable-next-line no-new
                    new Clipboard({
                      text: window.location.href,
                      success: function success() {
                        vm.toast('已复制链接');
                      },
                      error: function error() {
                        vm.toast('暂不支持复制功能，可手动分享此页面到微信打开或者直接复制该页面地址！');
                      }
                    });

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function confirm() {
            return _confirm2.apply(this, arguments);
          }

          return confirm;
        }()
      });
    }
  } catch (e) {
    console.error(e);
  }

  return result;
}

function endTip(vm) {
  var config = window.setting.活动引导 || {};

  if (!config.开启) {
    return;
  }

  if (new Date(store.state.now) > new Date(config.活动结束时间)) {
    vm.alert({
      msg: config.文案 || '活动已经结束啦，更多福利请前往福利社参与',
      confirmText: '去看看',
      confirm: function confirm() {
        window.location.href = config.跳转链接 || 'https://film.qq.com/x/autovue/welfare2018/?ptag=303-buffer';
      }
    });
  }
}

export { hackLitApp, hackWeibo, endTip };